import React from "react";
import "./EmptyContent.css";
import cn from "classnames";

const EmptyContent = (props) => {
    const {
        data, text, children, className,
    } = props;

    if (!data || (data && data.length === 0)) {
        return text && <span className={cn("EmptyContent", className)} key={1}>{text}</span>;
    }

    return children;
};

export default EmptyContent;
